module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "TitleLocation",
    class: _vm.classes
  }, [_c(_vm.titleWrapComponent, {
    tag: "component",
    staticClass: "TitleLocation-title",
    attrs: {
      "to": _vm.titleRoute
    }
  }, [_c('page-title', {
    attrs: {
      "title": _vm.title
    }
  })], 1), _vm._v(" "), (_vm.location) ? _c('p', {
    staticClass: "TitleLocation-location t-caps-md"
  }, [_c('span', {
    staticClass: "TitleLocation-locationArrow"
  }, [_vm._v("›")]), _vm._v("\n    " + _vm._s(_vm.location) + "\n  ")]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b77f47e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TitleLocation.vue
// module id = 778
// module chunks = 1474